import FormattedMessage from 'I18n/components/FormattedMessage';
import { Text } from 'foundations-components/components/Text';
import { ExternalLearningContentBanner } from '../../features/learningContent/index.migrated';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const LessonOverview = ({
  description,
  hubId,
  visibility
}) => {
  return /*#__PURE__*/_jsxs("div", {
    children: [/*#__PURE__*/_jsx(ExternalLearningContentBanner, {
      contentVisibility: visibility,
      hubId: hubId,
      marginBlockEnd: "600",
      marginBlockStart: "200"
    }), /*#__PURE__*/_jsx(Text, {
      as: "h4",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "learningCenter.lessonInformation.header"
      })
    }), /*#__PURE__*/_jsx("p", {
      children: description
    })]
  });
};
export default LessonOverview;